import {Button} from '@priority-software/priority-style-react';
import React, {useCallback} from 'react';
import {getLocalizedText, texts} from '../../../../../constants/TextConst';
import {chooseCloseZoomForm} from '../../../actions/zoom';

import {Screen, formsStore} from '../../../../../stores/Form';
import {SuspendedJobTypes} from '../../../consts/suspendedJobTypes';
import styles from './styles.module.scss';

interface Props {
    screen: Screen;
}

export const BackButton = (props: Props) => {
    const {screen} = props;

    const handleClick = useCallback(() => {
        chooseCloseZoomForm(screen);
        formsStore.setEventForRecordingMacro({
            type: SuspendedJobTypes.ZoomFormExit,
            session: screen.session
        });
    }, [screen]);

    return (
        <Button
            skin="secondary"
            onClick={handleClick}
            size="small"
            disabled={false}
            componentClasses={styles.button}
        >
            {getLocalizedText(texts.chooseValue)}
        </Button>
    );
};
